import React from 'react';

import Button from 'components/form/Button.component';

import DropdownMenuFooter from 'clientCommunications/components/Clients/common/DropdownMenuFooter.component';
import ServiceContainer from 'clientCommunications/components/Clients/common/ServiceItem';

const AllServiceDropDown = (props) => {
  const { totalServicesNumber, selectedServices, isServiceOpen, services } = props;

  const onDone = () => {
    props.filterService(selectedServices);
    props.closeServiceDropDown();
  };

  const allServiceSelected = totalServicesNumber === selectedServices.length;
  // TODO: update css classes

  return (
    <div className={`drop-down dd-service ${isServiceOpen ? '' : 'hidden'} `}>
      <div className="main">
        <span className="span-header">Only show clients who have visited for</span>
        <ul>
          {services.map((category) => (
            <ServiceContainer
              key={category.id}
              service={category}
              selectedServices={selectedServices}
              onSelectService={props.onSelectServiceItem}
            />
          ))}
        </ul>
      </div>
      <DropdownMenuFooter>
        <Button
          variant="slim"
          onClick={() => {
            props.onSelectAllService(allServiceSelected);
          }}
        >
          {allServiceSelected ? 'SELECT ALL' : 'CLEAR ALL'}
        </Button>
        <Button variant="slim" onClick={onDone}>
          DONE
        </Button>
      </DropdownMenuFooter>
    </div>
  );
};

export default AllServiceDropDown;
